import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useCallback, useRef, useEffect } from "react";
import { useStoreState } from "pullstate";
import Store from "../../../utils/Store";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import addEditPatient from "../../AddEditPatient/services/addEditPatient";
import constants from "../../../utils/constants";
import updateScanAssistCount from "../../PatientChannel/services/updateScanAssistCount";
import Toast from "../../Toast";
import { INITIAL_ZONE_PROGRESS, INITIAL_POINT_PROGRESS, ZONES } from "../types";
import { getNextIncompleteIndex, getPhaseFromProgress } from "../utils/scanAssistUtils";
import { get } from "lodash";
export function useScanAssist(_ref) {
  var patientDetail = _ref.patientDetail,
    patient_uid = _ref.patient_uid,
    isScanAssistModalOpen = _ref.isScanAssistModalOpen,
    inputRef = _ref.inputRef;
  var POCUS_ZONES = constants.POCUS_ZONES;
  var canEditScanCount = useStoreState(Store, function (s) {
    return s.canEditScanCount;
  });
  var scanAssistStatus = useStoreState(Store, function (s) {
    return s.scanAssistStatus;
  });
  var pocusAgeYears = get(patientDetail, ["additional", "pocus_registration_form_age_years_id"], undefined);
  var patientAgeYears = Number(pocusAgeYears !== null && pocusAgeYears !== void 0 ? pocusAgeYears : patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.age);
  var isPediatricPatient = patientAgeYears < 18;
  var pocusTriagedFor = String(get(patientDetail, ["pocus_triaged_for"], get(patientDetail, ["additional", "pocus_triaged_for"], ""))).toLowerCase().trim();
  var isTbTriaged = pocusTriagedFor === "tb";

  // View state
  var _useState = useState("menu"),
    currentView = _useState[0],
    setCurrentView = _useState[1];
  var shouldShowMediastinalProtocol = isPediatricPatient && isTbTriaged;
  var _useState2 = useState(""),
    scanCount = _useState2[0],
    setScanCount = _useState2[1];
  var _useState3 = useState(false),
    isSubmittingCount = _useState3[0],
    setIsSubmittingCount = _useState3[1];
  var getExistingScanCountString = useCallback(function () {
    var fromStatus = scanAssistStatus === null || scanAssistStatus === void 0 ? void 0 : scanAssistStatus.scan_assist_count;
    if (typeof fromStatus === "number" && !isNaN(fromStatus)) {
      return String(fromStatus);
    }
    var fromAdditional = get(patientDetail, ["additional", "scan_assist", "total_scan_count"], undefined);
    if (typeof fromAdditional === "number" && !isNaN(fromAdditional)) {
      return String(fromAdditional);
    }
    if (typeof fromAdditional === "string" && fromAdditional.trim().length > 0) {
      return String(fromAdditional).replace(/\D/g, "");
    }
    return "";
  }, [patientDetail, scanAssistStatus]);

  // Track which scan assist parts were used (for payload)
  var _useState4 = useState(false),
    didUseVolumeSweep = _useState4[0],
    setDidUseVolumeSweep = _useState4[1];
  var _useState5 = useState(false),
    didUsePointsProtocol = _useState5[0],
    setDidUsePointsProtocol = _useState5[1];
  var _useState6 = useState(false),
    didUseMediastinalProtocol = _useState6[0],
    setDidUseMediastinalProtocol = _useState6[1];
  var _useState7 = useState("volumeSweep"),
    selectedScanAssistStep = _useState7[0],
    setSelectedScanAssistStep = _useState7[1];

  // Volume Sweep Imaging state
  var _useState8 = useState(function () {
      return JSON.parse(JSON.stringify(INITIAL_ZONE_PROGRESS));
    }),
    volumeSweepZones = _useState8[0],
    setVolumeSweepZones = _useState8[1];
  var _useState9 = useState(0),
    currentZoneIndex = _useState9[0],
    setCurrentZoneIndex = _useState9[1];
  var _useState0 = useState("transverse"),
    zonePhase = _useState0[0],
    setZonePhase = _useState0[1];

  // 14 Point Protocol state
  var _useState1 = useState(function () {
      return JSON.parse(JSON.stringify(INITIAL_POINT_PROGRESS));
    }),
    protocolPoints = _useState1[0],
    setProtocolPoints = _useState1[1];
  var _useState10 = useState(0),
    currentPointIndex = _useState10[0],
    setCurrentPointIndex = _useState10[1];
  var _useState11 = useState("transverse"),
    pointPhase = _useState11[0],
    setPointPhase = _useState11[1];
  var _useState12 = useState(false),
    isLastPointSkipped = _useState12[0],
    setIsLastPointSkipped = _useState12[1];

  // Mediastinal Protocol state
  var _useState13 = useState(function () {
      return [{
        point: 1,
        transverse: false,
        longitudinal: false
      }, {
        point: 2,
        transverse: false,
        longitudinal: false
      }];
    }),
    mediastinalPoints = _useState13[0],
    setMediastinalPoints = _useState13[1];
  var _useState14 = useState(0),
    currentMediastinalPointIndex = _useState14[0],
    setCurrentMediastinalPointIndex = _useState14[1];
  var _useState15 = useState("transverse"),
    mediastinalPhase = _useState15[0],
    setMediastinalPhase = _useState15[1];
  var _useState16 = useState(false),
    isLastMediastinalPointSkipped = _useState16[0],
    setIsLastMediastinalPointSkipped = _useState16[1];
  var _useState17 = useState(false),
    isTransitioning = _useState17[0],
    setIsTransitioning = _useState17[1];

  // Build payload for scan assist data
  var buildScanAssistPayload = useCallback(function () {
    var totalCount = parseInt(scanCount, 10) || 0;
    var volumeSweepImaging = {};
    if (didUseVolumeSweep) {
      ZONES.forEach(function (zone, index) {
        var zoneData = volumeSweepZones[index];
        volumeSweepImaging["zone".concat(zone)] = {
          transverse: zoneData.transverse ? 1 : 0,
          longitudinal: zoneData.longitudinal ? 1 : 0
        };
      });
    }
    var pointsProtocol = {};
    if (didUsePointsProtocol) {
      protocolPoints.forEach(function (point, index) {
        var _POCUS_ZONES$index;
        pointsProtocol["".concat((_POCUS_ZONES$index = POCUS_ZONES[index]) === null || _POCUS_ZONES$index === void 0 ? void 0 : _POCUS_ZONES$index.toLowerCase())] = {
          transverse: point.transverse ? 1 : 0,
          longitudinal: point.longitudinal ? 1 : 0
        };
      });
    }
    var mediastinalProtocol = {};
    if (didUseMediastinalProtocol) {
      var labels = ["sst", "pst"];
      mediastinalPoints.forEach(function (point, index) {
        mediastinalProtocol[labels[index] || "point".concat(index + 1)] = {
          transverse: point.transverse ? 1 : 0,
          longitudinal: point.longitudinal ? 1 : 0
        };
      });
    }
    return {
      total_scan_count: totalCount,
      volume_sweep_imaging: didUseVolumeSweep ? volumeSweepImaging : {},
      points_protocol: didUsePointsProtocol ? pointsProtocol : {},
      mediastinal_protocol: didUseMediastinalProtocol ? mediastinalProtocol : {}
    };
  }, [scanCount, didUseVolumeSweep, didUsePointsProtocol, didUseMediastinalProtocol, volumeSweepZones, protocolPoints, mediastinalPoints, POCUS_ZONES]);
  var resetState = useCallback(function () {
    setCurrentView("menu");
    setScanCount("");
    setDidUseVolumeSweep(false);
    setDidUsePointsProtocol(false);
    setDidUseMediastinalProtocol(false);
    setSelectedScanAssistStep("volumeSweep");
    setVolumeSweepZones(JSON.parse(JSON.stringify(INITIAL_ZONE_PROGRESS)));
    setCurrentZoneIndex(0);
    setZonePhase("transverse");
    setProtocolPoints(JSON.parse(JSON.stringify(INITIAL_POINT_PROGRESS)));
    setCurrentPointIndex(0);
    setPointPhase("transverse");
    setIsLastPointSkipped(false);
    setMediastinalPoints([{
      point: 1,
      transverse: false,
      longitudinal: false
    }, {
      point: 2,
      transverse: false,
      longitudinal: false
    }]);
    setCurrentMediastinalPointIndex(0);
    setMediastinalPhase("transverse");
    setIsLastMediastinalPointSkipped(false);
    setIsTransitioning(false);
  }, []);
  var prevPatientUidRef = useRef(patient_uid);
  useEffect(function () {
    if (!isScanAssistModalOpen || !patient_uid) {
      resetState();
    } else if (prevPatientUidRef.current !== patient_uid) {
      resetState();
    }
    prevPatientUidRef.current = patient_uid;
  }, [isScanAssistModalOpen, patient_uid, resetState]);
  var handleClose = useCallback(function () {
    setCurrentView("menu");
    resetState();
  }, [resetState]);
  var handleEnterScanCount = useCallback(function () {
    setDidUseVolumeSweep(false);
    setDidUsePointsProtocol(false);
    setScanCount(getExistingScanCountString());
    setCurrentView("enterCount");
    setTimeout(function () {
      var _inputRef$current;
      return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }, 100);
  }, [getExistingScanCountString, inputRef]);
  var handleScanAssist = useCallback(function () {
    trackEvent(MIXPANEL_EVENTS.ASSISTANT_OPEN);
    setCurrentView("scanAssist");
  }, []);
  var startFullScanAssistFlow = useCallback(function () {
    setDidUseVolumeSweep(true);
    setDidUsePointsProtocol(true);
    setDidUseMediastinalProtocol(shouldShowMediastinalProtocol);
    setVolumeSweepZones(JSON.parse(JSON.stringify(INITIAL_ZONE_PROGRESS)));
    setProtocolPoints(JSON.parse(JSON.stringify(INITIAL_POINT_PROGRESS)));
    setMediastinalPoints([{
      point: 1,
      transverse: false,
      longitudinal: false
    }, {
      point: 2,
      transverse: false,
      longitudinal: false
    }]);
    setCurrentZoneIndex(0);
    setZonePhase("transverse");
    setCurrentPointIndex(0);
    setPointPhase("transverse");
    setIsLastPointSkipped(false);
    setCurrentMediastinalPointIndex(0);
    setMediastinalPhase("transverse");
    setIsLastMediastinalPointSkipped(false);
    setIsTransitioning(false);
    setCurrentView("volumeSweep");
  }, [shouldShowMediastinalProtocol]);
  var jumpToVolumeSweep = useCallback(function () {
    setDidUseVolumeSweep(true);
    setDidUsePointsProtocol(true);
    setDidUseMediastinalProtocol(shouldShowMediastinalProtocol);
    setVolumeSweepZones(JSON.parse(JSON.stringify(INITIAL_ZONE_PROGRESS)));
    setMediastinalPoints([{
      point: 1,
      transverse: false,
      longitudinal: false
    }, {
      point: 2,
      transverse: false,
      longitudinal: false
    }]);
    setCurrentZoneIndex(0);
    setZonePhase("transverse");
    setCurrentMediastinalPointIndex(0);
    setMediastinalPhase("transverse");
    setIsLastMediastinalPointSkipped(false);
    setIsTransitioning(false);
    setCurrentView("volumeSweep");
  }, [shouldShowMediastinalProtocol]);
  var jumpToFourteenPoint = useCallback(function () {
    setDidUseVolumeSweep(false);
    setDidUsePointsProtocol(true);
    setDidUseMediastinalProtocol(shouldShowMediastinalProtocol);
    setProtocolPoints(JSON.parse(JSON.stringify(INITIAL_POINT_PROGRESS)));
    setMediastinalPoints([{
      point: 1,
      transverse: false,
      longitudinal: false
    }, {
      point: 2,
      transverse: false,
      longitudinal: false
    }]);
    setCurrentPointIndex(0);
    setPointPhase("transverse");
    setIsLastPointSkipped(false);
    setCurrentMediastinalPointIndex(0);
    setMediastinalPhase("transverse");
    setIsLastMediastinalPointSkipped(false);
    setIsTransitioning(false);
    setCurrentView("fourteenPoint");
  }, [shouldShowMediastinalProtocol]);
  var jumpToMediastinalProtocol = useCallback(function () {
    setDidUseVolumeSweep(false);
    setDidUsePointsProtocol(false);
    setDidUseMediastinalProtocol(true);
    setMediastinalPoints([{
      point: 1,
      transverse: false,
      longitudinal: false
    }, {
      point: 2,
      transverse: false,
      longitudinal: false
    }]);
    setCurrentMediastinalPointIndex(0);
    setMediastinalPhase("transverse");
    setIsLastMediastinalPointSkipped(false);
    setIsTransitioning(false);
    setCurrentView("mediastinalProtocol");
  }, []);
  var handleSubmitCount = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _patientDetail$patien;
    var totalCount, uid, result, scanAssistPayload, patientData, errorMessage, _t, _t2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          if (!isSubmittingCount) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          if (!(canEditScanCount === false)) {
            _context.n = 2;
            break;
          }
          return _context.a(2);
        case 2:
          if (scanCount.trim()) {
            _context.n = 3;
            break;
          }
          Toast.error("Please enter a scan count");
          return _context.a(2);
        case 3:
          totalCount = parseInt(scanCount, 10);
          if (!(isNaN(totalCount) || totalCount < 0)) {
            _context.n = 4;
            break;
          }
          Toast.error("Please enter a valid scan count");
          return _context.a(2);
        case 4:
          uid = Number((_patientDetail$patien = patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid) !== null && _patientDetail$patien !== void 0 ? _patientDetail$patien : patient_uid);
          if (uid) {
            _context.n = 5;
            break;
          }
          Toast.error("Failed to save scan count");
          return _context.a(2);
        case 5:
          setIsSubmittingCount(true);
          _context.p = 6;
          _context.n = 7;
          return updateScanAssistCount(uid, totalCount);
        case 7:
          result = _context.v;
          if (result !== null && result !== void 0 && result.success) {
            _context.n = 8;
            break;
          }
          Toast.error((result === null || result === void 0 ? void 0 : result.message) || "Failed to save scan count");
          return _context.a(2);
        case 8:
          Store.update(function (s) {
            s.scanAssistStatus = _objectSpread(_objectSpread(_objectSpread({}, s.scanAssistStatus || {}), result), {}, {
              scan_assist_count: totalCount
            });
            s.scanAssistRefetchTrigger = Date.now();
          });
          scanAssistPayload = buildScanAssistPayload();
          patientData = {
            patient_uid: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
            additional: _objectSpread(_objectSpread({}, (patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.additional) || {}), {}, {
              scan_assist: scanAssistPayload
            })
          };
          _context.p = 9;
          _context.n = 10;
          return addEditPatient(patientData, true, patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.source_id);
        case 10:
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t = _context.v;
        case 12:
          Store.update(function (s) {
            s.isScanAssistModalOpen = false;
          });
          resetState();
          _context.n = 14;
          break;
        case 13:
          _context.p = 13;
          _t2 = _context.v;
          errorMessage = get(_t2, ["response", "data", "message"]) || "Failed to save scan count";
          Toast.error(errorMessage);
        case 14:
          _context.p = 14;
          setIsSubmittingCount(false);
          return _context.f(14);
        case 15:
          return _context.a(2);
      }
    }, _callee, null, [[9, 11], [6, 13, 14, 15]]);
  })), [buildScanAssistPayload, patientDetail, patient_uid, resetState, scanCount, canEditScanCount, isSubmittingCount]);
  var handleInputChange = useCallback(function (value) {
    setScanCount(String(value).replace(/\D/g, ""));
  }, []);
  var goToMediastinalFromFlow = useCallback(function () {
    setDidUseMediastinalProtocol(true);
    setMediastinalPoints([{
      point: 1,
      transverse: false,
      longitudinal: false
    }, {
      point: 2,
      transverse: false,
      longitudinal: false
    }]);
    setCurrentMediastinalPointIndex(0);
    setMediastinalPhase("transverse");
    setIsLastMediastinalPointSkipped(false);
    setIsTransitioning(false);
    setCurrentView("mediastinalProtocol");
  }, []);
  var isZoneComplete = function isZoneComplete(z) {
    return Boolean((z === null || z === void 0 ? void 0 : z.transverse) && (z === null || z === void 0 ? void 0 : z.longitudinal));
  };
  var isPointComplete = function isPointComplete(p) {
    return Boolean((p === null || p === void 0 ? void 0 : p.transverse) && (p === null || p === void 0 ? void 0 : p.longitudinal));
  };
  var handleVolumeSweepNext = useCallback(function () {
    if (isTransitioning) return;
    if (zonePhase === "transverse") {
      setVolumeSweepZones(function (prev) {
        var updated = _toConsumableArray(prev);
        updated[currentZoneIndex] = _objectSpread(_objectSpread({}, updated[currentZoneIndex]), {}, {
          transverse: true
        });
        return updated;
      });
      setZonePhase("longitudinal");
    } else if (zonePhase === "longitudinal") {
      setVolumeSweepZones(function (prev) {
        var updated = _toConsumableArray(prev);
        updated[currentZoneIndex] = _objectSpread(_objectSpread({}, updated[currentZoneIndex]), {}, {
          longitudinal: true
        });
        return updated;
      });
      setIsTransitioning(true);
      setZonePhase("submit");
      setTimeout(function () {
        setIsTransitioning(false);
        var nextIndex = getNextIncompleteIndex(volumeSweepZones, currentZoneIndex, isZoneComplete);
        if (nextIndex !== -1) {
          setCurrentZoneIndex(nextIndex);
          setZonePhase(getPhaseFromProgress(volumeSweepZones[nextIndex]));
        } else {
          setDidUseVolumeSweep(true);
          setDidUsePointsProtocol(true);
          setCurrentView("fourteenPoint");
          setCurrentZoneIndex(0);
          setZonePhase("transverse");
        }
      }, 600);
    }
  }, [currentZoneIndex, zonePhase, isTransitioning, volumeSweepZones]);
  var handleVolumeSweepSkip = useCallback(function () {
    var nextIndex = getNextIncompleteIndex(volumeSweepZones, currentZoneIndex, isZoneComplete);
    if (nextIndex !== -1) {
      setCurrentZoneIndex(nextIndex);
      setZonePhase(getPhaseFromProgress(volumeSweepZones[nextIndex]));
    } else {
      setDidUseVolumeSweep(true);
      setDidUsePointsProtocol(true);
      setCurrentView("fourteenPoint");
      setCurrentZoneIndex(0);
      setZonePhase("transverse");
    }
  }, [currentZoneIndex, volumeSweepZones]);
  var handleJumpToVolumeSweepZone = useCallback(function (index) {
    if (index === currentZoneIndex) return;
    var target = volumeSweepZones[index];
    if (target !== null && target !== void 0 && target.transverse && target !== null && target !== void 0 && target.longitudinal) return;
    setIsTransitioning(false);
    setCurrentZoneIndex(index);
    setZonePhase(target !== null && target !== void 0 && target.transverse && !(target !== null && target !== void 0 && target.longitudinal) ? "longitudinal" : "transverse");
  }, [currentZoneIndex, volumeSweepZones]);
  var handleProtocolNext = useCallback(function () {
    if (isTransitioning) return;
    if (pointPhase === "transverse") {
      setProtocolPoints(function (prev) {
        var updated = _toConsumableArray(prev);
        updated[currentPointIndex] = _objectSpread(_objectSpread({}, updated[currentPointIndex]), {}, {
          transverse: true
        });
        return updated;
      });
      setPointPhase("longitudinal");
    } else if (pointPhase === "longitudinal") {
      setProtocolPoints(function (prev) {
        var updated = _toConsumableArray(prev);
        updated[currentPointIndex] = _objectSpread(_objectSpread({}, updated[currentPointIndex]), {}, {
          longitudinal: true
        });
        return updated;
      });
      setPointPhase("submit");
      var nextIndex = getNextIncompleteIndex(protocolPoints, currentPointIndex, isPointComplete);
      if (nextIndex !== -1) {
        setIsTransitioning(true);
        setTimeout(function () {
          setIsTransitioning(false);
          setCurrentPointIndex(nextIndex);
          setPointPhase(getPhaseFromProgress(protocolPoints[nextIndex]));
        }, 600);
      } else if (shouldShowMediastinalProtocol) {
        setDidUsePointsProtocol(true);
        setDidUseMediastinalProtocol(true);
        setIsTransitioning(true);
        setTimeout(function () {
          setIsTransitioning(false);
          goToMediastinalFromFlow();
        }, 600);
      }
    }
  }, [currentPointIndex, pointPhase, isTransitioning, protocolPoints, shouldShowMediastinalProtocol, goToMediastinalFromFlow]);
  var handleProtocolSkip = useCallback(function () {
    var nextIndex = getNextIncompleteIndex(protocolPoints, currentPointIndex, isPointComplete);
    if (nextIndex !== -1) {
      setCurrentPointIndex(nextIndex);
      setPointPhase(getPhaseFromProgress(protocolPoints[nextIndex]));
      setIsLastPointSkipped(false);
      return;
    }
    if (shouldShowMediastinalProtocol) {
      setDidUsePointsProtocol(true);
      setDidUseMediastinalProtocol(true);
      goToMediastinalFromFlow();
      return;
    }
    setPointPhase("submit");
    setIsLastPointSkipped(pointPhase === "transverse");
  }, [currentPointIndex, pointPhase, protocolPoints, shouldShowMediastinalProtocol, goToMediastinalFromFlow]);
  var handleJumpToFourteenPoint = useCallback(function (index) {
    if (index === currentPointIndex) return;
    var target = protocolPoints[index];
    if (target !== null && target !== void 0 && target.transverse && target !== null && target !== void 0 && target.longitudinal) return;
    setIsTransitioning(false);
    setIsLastPointSkipped(false);
    setCurrentPointIndex(index);
    setPointPhase(target !== null && target !== void 0 && target.transverse && !(target !== null && target !== void 0 && target.longitudinal) ? "longitudinal" : "transverse");
  }, [currentPointIndex, protocolPoints]);
  var handleProtocolComplete = useCallback(function () {
    setDidUsePointsProtocol(true);
    if (shouldShowMediastinalProtocol) {
      goToMediastinalFromFlow();
      return;
    }
    setScanCount(getExistingScanCountString());
    setCurrentView("enterCount");
    setTimeout(function () {
      var _inputRef$current2;
      return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.focus();
    }, 100);
  }, [shouldShowMediastinalProtocol, goToMediastinalFromFlow, inputRef, getExistingScanCountString]);
  var handleMediastinalNext = useCallback(function () {
    if (isTransitioning) return;
    if (mediastinalPhase === "transverse") {
      setMediastinalPoints(function (prev) {
        var updated = _toConsumableArray(prev);
        updated[currentMediastinalPointIndex] = _objectSpread(_objectSpread({}, updated[currentMediastinalPointIndex]), {}, {
          transverse: true
        });
        return updated;
      });
      setMediastinalPhase("longitudinal");
    } else if (mediastinalPhase === "longitudinal") {
      setMediastinalPoints(function (prev) {
        var updated = _toConsumableArray(prev);
        updated[currentMediastinalPointIndex] = _objectSpread(_objectSpread({}, updated[currentMediastinalPointIndex]), {}, {
          longitudinal: true
        });
        return updated;
      });
      setMediastinalPhase("submit");
      var nextIndex = getNextIncompleteIndex(mediastinalPoints, currentMediastinalPointIndex, isPointComplete);
      if (nextIndex !== -1) {
        setIsTransitioning(true);
        setTimeout(function () {
          setIsTransitioning(false);
          setCurrentMediastinalPointIndex(nextIndex);
          setMediastinalPhase(getPhaseFromProgress(mediastinalPoints[nextIndex]));
        }, 600);
      }
    }
  }, [isTransitioning, mediastinalPhase, currentMediastinalPointIndex, mediastinalPoints]);
  var handleMediastinalSkip = useCallback(function () {
    var nextIndex = getNextIncompleteIndex(mediastinalPoints, currentMediastinalPointIndex, isPointComplete);
    if (nextIndex !== -1) {
      setCurrentMediastinalPointIndex(nextIndex);
      setMediastinalPhase(getPhaseFromProgress(mediastinalPoints[nextIndex]));
      setIsLastMediastinalPointSkipped(false);
    } else {
      setMediastinalPhase("submit");
      setIsLastMediastinalPointSkipped(mediastinalPhase === "transverse");
    }
  }, [currentMediastinalPointIndex, mediastinalPoints, mediastinalPhase]);
  var handleMediastinalComplete = useCallback(function () {
    setDidUseMediastinalProtocol(true);
    setScanCount(getExistingScanCountString());
    setCurrentView("enterCount");
    setTimeout(function () {
      var _inputRef$current3;
      return (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
    }, 100);
  }, [inputRef, getExistingScanCountString]);
  var handleJumpToMediastinalPoint = useCallback(function (index) {
    if (index === currentMediastinalPointIndex) return;
    var target = mediastinalPoints[index];
    if (target !== null && target !== void 0 && target.transverse && target !== null && target !== void 0 && target.longitudinal) return;
    setIsTransitioning(false);
    setIsLastMediastinalPointSkipped(false);
    setCurrentMediastinalPointIndex(index);
    setMediastinalPhase(target !== null && target !== void 0 && target.transverse && !(target !== null && target !== void 0 && target.longitudinal) ? "longitudinal" : "transverse");
  }, [currentMediastinalPointIndex, mediastinalPoints]);
  return {
    // View
    currentView: currentView,
    shouldShowMediastinalProtocol: shouldShowMediastinalProtocol,
    // Scan count
    scanCount: scanCount,
    handleInputChange: handleInputChange,
    handleSubmitCount: handleSubmitCount,
    isSubmittingCount: isSubmittingCount,
    isSubmitCountDisabled: isSubmittingCount || canEditScanCount === false || !scanCount.trim(),
    // Menu / navigation
    handleClose: handleClose,
    handleEnterScanCount: handleEnterScanCount,
    handleScanAssist: handleScanAssist,
    startFullScanAssistFlow: startFullScanAssistFlow,
    setSelectedScanAssistStep: setSelectedScanAssistStep,
    selectedScanAssistStep: selectedScanAssistStep,
    jumpToVolumeSweep: jumpToVolumeSweep,
    jumpToFourteenPoint: jumpToFourteenPoint,
    jumpToMediastinalProtocol: jumpToMediastinalProtocol,
    onSelectStep: function onSelectStep(id) {
      setSelectedScanAssistStep(id);
      if (id === "volumeSweep") jumpToVolumeSweep();else if (id === "fourteenPoint") jumpToFourteenPoint();else if (id === "enterCount") handleEnterScanCount();else if (id === "mediastinal") jumpToMediastinalProtocol();
    },
    // Volume Sweep
    volumeSweepZones: volumeSweepZones,
    currentZoneIndex: currentZoneIndex,
    zonePhase: zonePhase,
    isTransitioning: isTransitioning,
    handleVolumeSweepNext: handleVolumeSweepNext,
    handleVolumeSweepSkip: handleVolumeSweepSkip,
    handleJumpToVolumeSweepZone: handleJumpToVolumeSweepZone,
    // 14 Point
    protocolPoints: protocolPoints,
    currentPointIndex: currentPointIndex,
    pointPhase: pointPhase,
    isLastPointSkipped: isLastPointSkipped,
    handleProtocolNext: handleProtocolNext,
    handleProtocolSkip: handleProtocolSkip,
    handleJumpToFourteenPoint: handleJumpToFourteenPoint,
    handleProtocolComplete: handleProtocolComplete,
    // Mediastinal
    mediastinalPoints: mediastinalPoints,
    currentMediastinalPointIndex: currentMediastinalPointIndex,
    mediastinalPhase: mediastinalPhase,
    isLastMediastinalPointSkipped: isLastMediastinalPointSkipped,
    handleMediastinalNext: handleMediastinalNext,
    handleMediastinalSkip: handleMediastinalSkip,
    handleMediastinalComplete: handleMediastinalComplete,
    handleJumpToMediastinalPoint: handleJumpToMediastinalPoint
  };
}